import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const ShoppingCart: React.FC = () => {
  const { cart, removeFromCart, updateHours } = useCart();
  const [isOpen, setIsOpen] = useState(false);

  const toggleCart = () => {
    setIsOpen(!isOpen);
  };

  const handleUpdateHours = (employeeId: string, e: React.ChangeEvent<HTMLInputElement>) => {
    const hours = parseInt(e.target.value);
    if (hours > 0) {
      updateHours(employeeId, hours);
    }
  };

  return (
    <div className="shopping-cart-container">
      <button
        className="futuristic-cart-button"
        onClick={toggleCart}
        aria-label="Shopping Cart"
      >
        <span className="cart-icon">🛒</span>
        {cart.items.length > 0 && (
          <span className="cart-count">{cart.items.length}</span>
        )}
        <span className="cart-glow"></span>
      </button>

      {isOpen && (
        <div className="cart-dropdown futuristic-dropdown">
          <div className="cart-header futuristic-cart-header">
            <h3><span className="cart-header-icon">🛒</span> Shopping Cart</h3>
            <button
              className="close-button futuristic-close"
              onClick={toggleCart}
              aria-label="Close Cart"
            >
              ✕
            </button>
          </div>

          {cart.items.length === 0 ? (
            <div className="empty-cart">
              <div className="empty-cart-icon">🤖</div>
              <p>Your cart is empty</p>
              <p className="empty-cart-subtitle">Add AI employees to get started</p>
            </div>
          ) : (
            <>
              <ul className="cart-items">
                {cart.items.map(item => (
                  <li key={item.employee.id} className="cart-item futuristic-cart-item">
                    <div className="cart-item-image">
                      <img src={item.employee.avatar} alt={item.employee.name} />
                    </div>
                    <div className="cart-item-details">
                      <h4>{item.employee.name}</h4>
                      <p className="cart-item-rate">${item.employee.hourlyRate}/hour</p>
                      <div className="cart-item-hours">
                        <label htmlFor={`hours-${item.employee.id}`}>Hours:</label>
                        <input
                          id={`hours-${item.employee.id}`}
                          type="number"
                          min="1"
                          value={item.hours}
                          onChange={(e) => handleUpdateHours(item.employee.id, e)}
                        />
                      </div>
                      <p className="cart-item-subtotal">
                        Subtotal: ${(item.employee.hourlyRate * item.hours).toFixed(2)}
                      </p>
                    </div>
                    <button
                      className="remove-button futuristic-remove"
                      onClick={() => removeFromCart(item.employee.id)}
                      aria-label={`Remove ${item.employee.name} from cart`}
                    >
                      <span className="remove-icon">✕</span>
                    </button>
                  </li>
                ))}
              </ul>

              <div className="cart-footer futuristic-cart-footer">
                <div className="cart-total">
                  <span>Total:</span>
                  <span className="total-amount">${cart.total.toFixed(2)}</span>
                </div>
                <Link to="/cart" className="checkout-button futuristic-checkout">
                  <span className="checkout-icon">💳</span> View Cart
                </Link>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ShoppingCart;
